export const categories = [
  { id: 'weekly-hot', name: '本周热门', slug: 'weekly-hot', icon: 'ri-fire-line', count: 128 },
  { id: 'celebrity-gossip', name: '明星八卦', slug: 'celebrity-gossip', icon: 'ri-star-line', count: 256 },
  { id: 'internet-drama', name: '网红爆料', slug: 'internet-drama', icon: 'ri-user-smile-line', count: 189 },
  { id: 'scandal', name: '黑料吃瓜', slug: 'scandal', icon: 'ri-chat-smile-2-line', count: 312 },
  { id: 'daily-update', name: '每日更新', slug: 'daily-update', icon: 'ri-calendar-check-line', count: 445 },
  { id: 'hot-comments', name: '热评精选', slug: 'hot-comments', icon: 'ri-chat-1-line', count: 167 },
];